import { Link } from "react-router-dom";

export default function DcTab(props){

    return (
        <>
         <ul className="dc_nav">
                    <li className={`cus-tab ${props.id==1?'active':''}`}><Link to={`/site/${props.site_id}/dc_energy_meter`}>Overview</Link></li>
                    <li className={`cus-tab ${props.id==2?'active':''}`}><Link to={`/site/${props.site_id}/dc_energy_meter/graph`}>Graph</Link></li>
                </ul>
        </>
    )
}